<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 18:34:25
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchManage\components\Gps\newGps.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-08-03 17:05:00
-->
<template>
  <normalDialog
    :dialog="show"
    :title="$t('label_essweb_punchManage_list_gps_dialog_newTitle')"
    @close="closeDialog"
    :width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              color="primary"
              v-model="Data.status"
              :label="
                Data.status
                  ? $t('label_essweb_punchManage_list_gps_dialog_activeLabel')
                  : ''
              "
            ></v-switch>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              maxlength="100"
              :bindData="Data.criteria_gps_name"
              @change="
                (valueArr) => {
                  Data.criteria_gps_name = valueArr;
                }
              "
              :label="$t('label_essweb_punchManage_list_gps_dialog_nameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              maxlength="500"
              :bindData="Data.criteria_gps_description"
              @change="
                (valueArr) => {
                  Data.criteria_gps_description = valueArr;
                }
              "
              :label="
                $t('label_essweb_punchManage_list_gps_dialog_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              type="number"
              maxlength="10"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
              "
              :label="
                $t(
                  'label_essweb_punchManage_list_gps_dialog_distanceMeterLabel'
                )
              "
              v-model="Data.within_distance_meter"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :max="Data.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultTime="Data.effective_utc_datetime"
              :label="
                $t(
                  'label_essweb_punchManage_list_gps_dialog_effectiveStartDateLabel'
                )
              "
              @change="(time) => (Data.effective_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
            <v-sheet class="text--secondary">Time Zone</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              v-model="Data.effective_time_zone"
              dense
              placeholder="time zone"
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :min="Data.effective_utc_datetime"
              :defaultTime="Data.expired_utc_datetime"
              :label="
                $t(
                  'label_essweb_punchManage_list_gps_dialog_expiredEndDateLabel'
                )
              "
              @change="(time) => (Data.expired_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_gps_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              v-model="Data.expired_time_zone"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :placeholder="
                $t('label_essweb_punchManage_list_gps_dialog_timeZoneLabel')
              "
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_gps_dialog_remarkLabel")
            }}</v-sheet>
            <v-text-field
              dense
              single-line
              filled
              :placeholder="
                $t('label_essweb_punchManage_list_gps_dialog_remarkLabel')
              "
              maxlength="500"
              v-model="Data.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newWifi",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  props: { show: { default: false, type: Boolean } },
  data() {
    return {
      Data: {
        status: 0,
        criteria_gps_name: "",
        criteria_gps_description: "",
        within_distance_meter: 0,
        effective_utc_datetime: "",
        effective_time_zone: "",
        expired_utc_datetime: "",
        expired_time_zone: "",
        criteria_type_uuid: "",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.Data = {
          status: 0,
          criteria_gps_name: "",
          criteria_gps_description: "",
          within_distance_meter: 0,
          effective_utc_datetime: "",
          effective_time_zone: "",
          expired_utc_datetime: "",
          expired_time_zone: "",
          criteria_type_uuid: "",
          remarks: "",
        };
      }
    },
    "Data.expired_time_zone": function (val) {
      this.Data.effective_time_zone = val;
    },
  },
  mounted() {
    this.Data.criteria_gps_name = this.$getCommonLangKey(this.companyLang);
    this.Data.criteria_gps_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.Data.effective_time_zone = this.defaultUTC;
    this.Data.expired_time_zone = this.defaultUTC;
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", "gps", this.Data);
    },
  },
};
</script>
